// Use the environment variable directly from build time
const apiUrl: string = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
// const apiUrl: string = process.env.REACT_APP_API_URL || 'https://begard-api-production.up.railway.app';

export function getApiUrl(): string {
  return apiUrl;
} 
